<template>
    <div class="d-none">
        <div :id="modal_id" class="modal-box">
            <div class="close-button"> <a href="#" class="modal-close white"></a> </div>
            <div class="modal-container padding0">
                <div v-if="!doNotShowImage" class="modal-banner">
                    <div class="featured">
                        <span class="img-name" :style="{ backgroundImage: 'url(' + image + ')' }"></span>
                    </div>
                </div>
                <div class="modal-forms">
                    <h4 class="fs-3 mb-3 ">
                        Hi {{this.user_name ? this.user_name : ''}},
                    </h4>
                    <p class="boldfs-4">Before we can get started</p>
                    <p class="mb-3 fs-4">Please enter your Ulta Beauty Rewards<sup>&trade;</sup> Mastercard<sup>&reg;</sup> Credit Card below.</p>
                    <div class="form-container">
                        <div class="form-element">
                            <input id="card-no-enroll" type="text" class="form-control" v-model="card_no" maxlength="19" @input="card_no = card_no.replace(/[^0-9-]/g, '')" autocomplete="_card_no">
                        </div>
                        <div class="form-element custom-checkbox">
                            <input :name="randomNumberTerms" type="checkbox" class="styled-checkbox" :id="randomNumberTerms" v-model="termsConditions" >
                            <label :for="randomNumberTerms">By checking this box and entering my payment card information, I authorize my Payment Card Network (Mastercard<sup>&reg;</sup>) to monitor and share transaction data associated with my registered payment card (including spending history) with Ulta Beauty Rewards<sup>&trade;</sup> and its third party service providers in accordance with the Program Terms &amp; Conditions and Privacy Policy.</label>
                        </div>
                        <div class="form-element custom-checkbox">
                            <input :name="randomNumberEmailOptIn" type="checkbox" class="styled-checkbox" :id="randomNumberEmailOptIn" v-model="emailOptin">
                            <label :for="randomNumberEmailOptIn">I want to receive email offers and promotions</label>
                        </div>
                        <div class="form-recaptcha flex-wrapper center-align">
                            <div class="form-element">
                                <vue-recaptcha
                                    :sitekey="siteKey"
                                    @verify="onCaptchaVerify"
                                    ref="recaptcha"
                                />
                                <span
                                    v-if="recaptcha_error"
                                    class="error-message"
                                >
                                Please confirm you are not a robot.
                            </span>
                            </div>
                        </div>
                        <div v-if="errors.length">
                            <b>Please correct the following error(s):</b>
                            <ul style="color: red" >
                                <li class="alert alert-danger" v-for="error in errors">{{ error }}</li>
                            </ul>
                        </div>
                        <div class="button-container no-margin text-center">
                            <input type="submit" id="enroll-btn" @click="handleSubmit" :disabled="registering" class="button pink midsize mid my-3" :value=" this.registering ? 'Please wait' : 'Register'">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { VueRecaptcha } from 'vue-recaptcha';
    export default {
        components: {VueRecaptcha},
        name: 'EnrollCardsComponent',
        props: ['offer', 'modalId', 'doNotShowImage'],
        data(){
            return {
                user: null,
                card_no:'',
                user_name: null,
                termsConditions: false,
                emailOptin: false,
                randomNumberEmailOptIn: 'email_opt_in'+_.random(1, 10000000) + _.random(1, 10000000),
                randomNumberTerms: 'terms'+_.random(1, 10000000) + _.random(1, 10000000),
                siteKey: ENV_RECAPTCHAV2_SITEKEY,
                g_recaptcha_response: null,
                recaptcha_error: false,
                registering: false,
                modal_id: this.getModalId(),
                errors: [],
                image: this.offer && this.offer.hasOwnProperty('MerchantImageURL') ? this.offer.MerchantImageURL : '../images/placeholder.jpg',
                    //(this.offer && this.offer.OfferId) ? 'enroll-cards-modal-'+this.offer.OfferId :'enroll-cards-modal-'+ _.random(1, 10000000) + _.random(1, 10000000)
            }
        },
        mounted() {
            if(localStorage.getItem('user_obj')) {
                this.user = JSON.parse(localStorage.getItem('user_obj'));
                this.user_name = _.capitalize(this.user.name);
            }
        },
        methods : {
            getModalId() {
                if (this.offer && this.offer.OfferId) {
                    return 'enroll-cards-modal-'+this.offer.OfferId;
                } else if(this.modalId) {
                    return 'enroll-cards-modal-'+this.modalId;
                } else {
                    return + _.random(1, 10000000) + _.random(1, 10000000)
                }
            },
            validate() {

                this.errors = [];

                if (isNaN(this.card_no) || this.card_no === '') {
                    this.errors.push('Valid card Number is required.');
                }

                if (this.emailOptin != true) {
                    // this.errors.push('terms and conditions consent is required.');
                }

                if (this.termsConditions != true) {
                    this.errors.push('Terms and conditions consent is required.');
                }

                return this.errors.length == 0;
            },
            handleSubmit(e) {
                this.errors = [];
            e.preventDefault();


            if(this.offer && this.offer.OfferId) {

                if(this.validate() && this.validateRecaptcha()) {
                    this.registering = true;
                    axios.post(this.apiEndPoints.enrollAndActivate, {
                        card_no: this.card_no,
                        termsConditions: this.termsConditions,
                        emailOptIn: this.emailOptin,
                        offer_id: this.offer && this.offer.OfferId ? this.offer.OfferId : null,
                        g_recaptcha_response: this.g_recaptcha_response,
                    })
                        .then(response => {
                            // console.log(response);

                            if (response.data) {
                                /**
                                 * if card enroll is successful we pass the user back
                                 */
                                if (response.data.user && response.data.user.id) {
                                    this.resetUserInLocalStorage(response.data.user);
                                    this.user = response.data.user;
                                }

                                if (response.data.offer && response.data.offer.ActivationId &&
                                    response.data.offer.Status && response.data.offer.Status == 'ACTIVATED') {
                                    /**
                                     * emit a global event, so that if the same offer is rendered any where else on DOM, we mark it activated as well.
                                     */
                                    this.$eventHub.$emit('offer_activated_' + this.offer.OfferId, this.offer.OfferId);

                                    this.$emit('reload', this.user);
                                    this.$emit('reloadOffer', response.data.offer);
                                    $.colorbox.close();
                                } else if (response.data.message) {
                                    // console.log(response.data.message, 'msg');
                                    this.$refs.recaptcha.reset();
                                    this.errors.push(response.data.message)
                                } else {
                                    this.$refs.recaptcha.reset();
                                    this.errors.push('An error occurred. Please try again!')
                                }

                            }
                        }).catch(error => {
                        this.$refs.recaptcha.reset();

                        if (error.response && error.response.status && error.response.status == 419) {
                            this.$router.push({ name: 'sign_in' });
                        } else if (error.response.data && error.response.data.message) {
                            // console.log(error.response.data.message, 'msg');
                            this.errors.push(error.response.data.message)
                        } else {
                            this.$refs.recaptcha.reset();
                            this.errors.push('An error occurred. Please try again!')
                        }
                    }).finally(() => {
                        this.registering = false;
                    });
                }

            } else {
                this.registering = true;
                axios.post(this.apiEndPoints.registerCard, {
                    card_no: this.card_no,
                    termsConditions: this.termsConditions,
                    emailOptIn: this.emailOptin,
                    g_recaptcha_response: this.g_recaptcha_response,
                })
                    .then(response => {
                            if (response.data && response.data.status && response.data.status == 'success') {

                                if (response.data.user && response.data.user.id) {
                                    this.resetUserInLocalStorage(response.data.user);
                                    this.user = response.data.user;

                                    this.$emit('reload', this.user);
                                    this.$emit('show_enroll_success');
                                    $.colorbox.close();
                                }
                            } else if (response.data.message) {
                                this.$refs.recaptcha.reset();
                                this.errors.push(response.data.message)
                            } else {
                                this.$refs.recaptcha.reset();
                                this.errors.push('An error occurred. Please try again!')
                            }

                    })
                    .catch(error => {
                        this.$refs.recaptcha.reset();
                        console.error(error.response);

                        if (error.response && error.response.status && error.response.status == 419) {
                            this.$router.push({ name: 'sign_in' });
                        } else {
                            this.errors.push('An error occurred. Please try again!')
                        }

                    }).finally(() => {
                    this.registering = false;
                });
            }
    },
            validateRecaptcha() {

                if(!this.g_recaptcha_response) {
                    this.recaptcha_error = true;

                    // return false;
                }

                return true;
            },

            onCaptchaVerify(token) {
                // Provide the token response to the form object.
                this.g_recaptcha_response = token;
            },
            },


    }
</script>

<style scoped>
    #card-no-enroll {
        width: 100%;
    }
</style>
